/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Right_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Bottom Right" |
*
* @param {Position_Bottom_Right_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_right_title = /** @type {((inputs?: Position_Bottom_Right_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Right_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : En Bas a Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Unten rechts")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: in basso a destra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Нижний правый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Abajo a la derecha")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：右下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置: 右下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति: नीचे दाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Inferior direita")
	return /** @type {LocalizedString} */ ("Position: Bottom Right")
});